import React, { useEffect, useRef, useState } from 'react';
import style from "./index.module.scss";
import cn from "classnames";
import UncheckCircleIcon from '../../shared/icons/UncheckCircleIcon';
import ArrowUpIcon from '../../shared/icons/ArrowUpIcon';
import CustomButton from '../../custom/custom-button/CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '../../shared/icons/CloseIcon';
import CustomInput from '../../custom/custom-input/CustomInput';
import { User } from '../../../services';
import { toast } from 'react-toastify';
import CheckVerifiedIcon from '../../shared/icons/CheckVerifiedIcon';
import ArrowDownIconNew from '../../shared/icons/ArrowDownIconNew';
import { setUserData } from '../../../store/actions/userAction';
import CircularProgress from '../../custom/circular-progress/CircularProgress';
import { validateEmail } from '../../../utils/checkEmail';
import {t} from "i18next";

const ConfirmEmail = ({
    user,
    isOpenEmail,
    setIsOpenEmail,
    setIsOpenDocuments,
    setIsOpenInstruction
}) => {
    const dispatch = useDispatch();
    const inputs = useRef([]);
    const [email, setEmail] = useState(user?.email || "");
    const [code, setCode] = useState(['', '', '', '']);
    const [errorTitleEmail, setErrorTitleEmail] = useState();

    const [isCodeValid, setIsCodeValid] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isOpenUpdateEmail, setIsOpenUpdateEmail] = useState(false);
    const [isOpenModalVerified, setIsOpenModalVerified] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingUpdateEmail, setIsLoadingUpdateEmail] = useState(false);

    const toggleLowerCard = () => {
        setIsOpenEmail(!isOpenEmail);
        setIsOpenDocuments(false);
        setIsOpenInstruction(false);
    };

    const handleChange = (value, index) => {
        if (/^\d$/.test(value)) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            if (index < inputs.current.length - 1) {
                inputs.current[index + 1].focus();
            }

            if (newCode.every(digit => digit !== '')) {
                setIsCodeValid(true);
            } else {
                setIsCodeValid(false);
            }
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            if (code[index]) {
                const newCode = [...code];
                newCode[index] = '';
                setCode(newCode);
                setIsCodeValid(false);
            } else if (index > 0) {
                inputs.current[index - 1].focus();
            }
        }
    };

    const handleSendCode = async () => {
        setIsLoading(true);

        if (user.emailConfirmed) {
            toast.info("Вы уже подтвердили почту");
            setIsLoading(false);
            return;
        }
        try {
            await User.sendConfirmationEmail(email);
            toast.info("Код подтверждения отправлен на вашу почту");
            setIsOpenModal(true);
        } catch (error) {
            console.error("Ошибка при отправке кода:", error);
            toast.error("Ошибка при отправке кода:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleСodeEmail = () => {
        setIsLoading(true);

        User.checkСodeEmail(code.join(''), email)
            .then(response => {
                if (response.data.isSucccess) {
                    // toast.success("Почта успешно подтвержден");
                    setIsLoading(false);
                    setIsOpenModal(false);
                    setIsOpenModalVerified(true);
                    updateUserData();
                }
            })
            .catch(error => {
                console.log("Введен неправильный код подтверждения:", error)
                toast.error("Введен неправильный код подтверждения")
                setIsLoading(false);
            });
    };

    // const updateUserStep = () => {
    //     User.updateStep(0)
    //         .then(() => {
    //             updateUserData();
    //             console.log("Step успешно обновлен");
    //         }).catch(error => {
    //             console.error("Error updating step:", error);
    //         });
    // };

    const updateUserEmail = () => {
        setIsLoadingUpdateEmail(true)
        if (!validateEmail(email)) {
            setErrorTitleEmail("Неверный формат электронной почты");
            setIsLoadingUpdateEmail(false);
            return;
        }
        User.updateEmail(email)
            .then(() => {
                console.log("email успешно обновлен");
                toast.success(`Почта успешно изменен, код подтверждение отправлен на ${email}`);
                // updateUserData();
                setIsLoadingUpdateEmail(false);
                setIsOpenUpdateEmail(false);
                setIsOpenModal(true);
            }).catch(error => {
                console.error("Error updating email:", error);
                toast.error(`Ошибка при измение почты:`, error);
                setIsLoadingUpdateEmail(false);
                setIsOpenUpdateEmail(false);
            });
    };

    const updateUserData = () => {
        User.get()
            .then(response => {
                console.log("[App]", response)
                dispatch(setUserData(response.data));
            })
            .catch(error => {
                console.log(error)
            });
    };

    // useEffect(() => {
    //     updateUserData();
    // }, []);

    const handleСhangeEmail = () => {
        setIsOpenUpdateEmail(true);
    }

    const handleClose = () => {
        setIsOpenModal(!isOpenModal);
    }

    const handleModalEmailClose = () => {
        setIsOpenUpdateEmail(!isOpenUpdateEmail);
    }

    const handleModalVerifiedClose = () => {
        setIsOpenModalVerified(false);
    }

    return (
        <>
            <div className={cn(style.card, { [style.isBg]: isOpenEmail })}>
                <div className={style.card_upper}>
                    <div className={style.card_head} onClick={toggleLowerCard}>
                        {user.emailConfirmed ? <CheckVerifiedIcon width={24} height={24} /> : <UncheckCircleIcon />}
                        <div className={style.card_title}>{t('onboarding.emailVerification.title')}</div>
                        {isOpenEmail ? <ArrowUpIcon style={{ cursor: 'pointer' }} /> : <ArrowDownIconNew style={{ cursor: 'pointer' }} />}
                    </div>
                    <div className={style.card_text}>
                        {user.emailConfirmed
                            ? t('onboarding.emailVerification.verifiedText')
                            : t('onboarding.emailVerification.verificationText', { email })}
                    </div>
                </div>
                <div className={cn(style.card_lower, { [style.isDisplay]: !isOpenEmail })}>
                    <CustomButton
                        text={t('onboarding.emailVerification.getCodeButton')}
                        isWhite
                        onClick={handleSendCode}
                        isLoading={isLoading}
                        isDisabled={user.emailConfirmed}
                    />
                    <CustomButton text={t('onboarding.emailVerification.changeEmailButton')} isUnderline onClick={handleСhangeEmail} />
                </div>
            </div>

            {isOpenModal && (
                <div className={cn('modal-overlay', style.modal)}>
                    <div className={cn(style.modal_content)}>
                        <div className={style.modal_text}>
                            <div className={style.modal_title}>
                                {t('onboarding.emailVerification.enterCode')}
                                <CloseIcon fill={'#6D7885'} onClick={handleClose} />
                            </div>
                            <div className={style.modal_description}>{t('onboarding.emailVerification.codeSent', { email })}</div>
                        </div>
                        <div className={style.codeInputs}>
                            {code.map((digit, index) => (
                                <input
                                    key={index}
                                    ref={(el) => (inputs.current[index] = el)}
                                    value={digit}
                                    type="text"
                                    maxLength={1}
                                    onChange={(e) => handleChange(e.target.value, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    className={style.codeInput}
                                    placeholder="0"
                                />
                            ))}
                            <div style={{ display: code.every((digit) => digit === '') ? 'none' : 'block' }}>
                                <CircularProgress size={24} strokeWidth={2} stages={4} currentStage={code.filter((digit) => digit).length} color="#2857FC" />
                            </div>
                        </div>
                        <div className={style.modal_btns}>
                            <CustomButton
                                isFall
                                isDisabled={!isCodeValid}
                                text={t('driversCreate.button.confirm')}
                                onClick={handleСodeEmail}
                                isLoading={isLoading}
                            />
                            <CustomButton text={t('onboarding.emailVerification.resendCodeButton')} isUnderline onClick={handleSendCode} />
                        </div>
                    </div>
                </div>
            )}

            {isOpenModalVerified && (
                <div className={cn('modal-overlay', style.modal)}>
                    <div className={cn(style.modal_content)}>
                        <div className={style.modal_text}>
                            <div className={style.modal_title}>
                                {t('onboarding.emailVerification.done')}
                                <CloseIcon fill={'#6D7885'} onClick={handleModalVerifiedClose} />
                            </div>
                        </div>
                        <div className={cn(style.modal_btns, style.modal_checkedText)}>
                            <CheckVerifiedIcon />
                            {t('onboarding.emailVerification.verifiedText')}
                        </div>
                    </div>
                </div>
            )}

            {isOpenUpdateEmail && (
                <div className={cn('modal-overlay', style.modal)}>
                    <div className={cn(style.modal_content, style.paddingBt)}>
                        <div className={style.modal_text}>
                            <div className={style.modal_title}>
                                {t('onboarding.emailVerification.enterEmail')}
                                <CloseIcon fill={'#6D7885'} onClick={handleModalEmailClose} />
                            </div>
                            <div className={style.modal_description}>{t('onboarding.emailVerification.newEmailText')}</div>
                        </div>
                        <CustomInput
                            placeholder={t('login.emailPlaceholder')}
                            labelText="E-mail"
                            inputType="text"
                            onChangeValue={setEmail}
                            value={email}
                            errorText={errorTitleEmail}
                            isDeleteText
                        />
                        <div className={style.modal_btns}>
                            <CustomButton
                                text={t('onboarding.emailVerification.getCodeForNewEmail')}
                                onClick={updateUserEmail}
                                isLoading={isLoadingUpdateEmail}
                                isFall
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ConfirmEmail;
